import React, {useState} from 'react';
import './survey.css';
import './result.scss';
import './start.scss';
import Loading from "./Loading";
import {ReactComponent as Go} from './img/go.svg';
import {ReactComponent as Logo} from './img/logo.svg';
import {ReactComponent as SubTitle} from './img/subtitle.svg';
import {ReactComponent as Couple} from './img/couple.svg';
import {ReactComponent as Icon2} from './img/icon2.svg';
import {ReactComponent as Icon3} from './img/icon3.svg';
import Clipboard from 'clipboard';

const UiPageList = [
    {
        id: 0,
        text: "마사지, 팩 등 피부관리를 정기적으로 한다.",
        type: 1,
        choice: 0,
    }, {
        id: 1,
        text: "자신이 어떤 연애를 하고 싶은지 구체적인 계획을 가지고 있다.",
        type: 2,
        choice: 0,
    }, {
        id: 2,
        text: "외출하기 전 어떠한 분위기를 연출할지 생각하고 이에 맞춰 스타일링한다.",
        type: 1,
        choice: 0,
    }, {
        id: 3,
        text: "이성이 좋아하는 대화 주제를 충분히 안다.",
        type: 2,
        choice: 0,
    }, {
        id: 4,
        text: "만남이 끝날 때, 최선의 끝맺는 자세를 알고 있다.",
        type: 3,
        choice: 0,
    }, {
        id: 5,
        text: "남들이 부러워할 만한 스펙을 갖추고 있다.",
        type: 2,
        choice: 0,
    }, {
        id: 6,
        text: "어떤 장소를 가야 자신의 이상형을 만날 확률이 높은지 알고 있다.",
        type: 3,
        choice: 0,
    }, {
        id: 7,
        text: "맛집을 제외하고 데이트하기에 좋은 장소들을 충분히 알고 있다.",
        type: 2,
        choice: 0,
    }, {
        id: 8,
        text: "들어갈 때나 나갈 때, 걸을 때를 신경 쓴다.",
        type: 3,
        choice: 0,
    }, {
        id: 9,
        text: "본인에게 어울리면서 상황에 맞는 헤어스타일을 하고 있다.",
        type: 1,
        choice: 0,
    }, {
        id: 10,
        text: "본인의 웃음소리가 상대에게 유쾌함을 준다고 생각한다. 이에 대해 깊게 생각해본 적이 있다.",
        type: 3,
        choice: 0,
    }, {
        id: 11,
        text: "자신이 원하는 몸매를 유지하기 위해 식이요법 또는 운동을 한다.",
        type: 1,
        choice: 0,
    }, {
        id: 12,
        text: "이성이 포함된 모임에 자주 나간다.",
        type: 3,
        choice: 0,
    }, {
        id: 13,
        text: "평소 교양을 쌓기 위해 또는 자기계발을 위해 책을 2주에 1권 이상 읽는다.",
        type: 2,
        choice: 0,
    }, {
        id: 14,
        text: "타인에게 좋은 향을 주기 위한 제품을 의도적으로 사용한다.",
        type: 1,
        choice: 0,
    }
];

function App(props) {
    const [step, setStep] = useState(0);
    const [isStart, setIsStart] = useState(true);
    const [isSurvey, setIsSurvey] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isResult, setIsResult] = useState(false);
    const [face, setFace] = useState(0);
    const [know, setKnow] = useState(0);
    const [attitude, setAttitude] = useState(0);
    const [result, setResult] = useState(0);
    const [bg, setBg] = useState('center');

    const Start = () => {
        return (
            <div className="start">
                <input type="radio" name="choice" id="start-nav-2" checked={true}/>
                <div id="start-app">
                    <nav className="ui-nav">
                        <div className="ui-bg">
                            <div className="ui-dot"/>
                        </div>
                        <label htmlFor="start-nav-2" className="ui-label" onClick={start}>
                            <span className="ui-icon">
                                <Go/>
                            </span>
                        </label>
                    </nav>

                    <div className="ui-pages">
                        <article className="ui-page" data-page="2">
                            <div className="start-bg">
                                <Logo style={{width: "40vw", maxWidth: "180px", marginTop: "5vh"}}/>
                                <figure>
                                    <img src={require("./img/title.svg")} alt="타이틀" />
                                </figure>
                                <SubTitle style={{width: "90vw", maxWidth: "360px", marginTop: "2px"}}/>
                                <Couple style={{width: "60vw", maxWidth: "270px", marginTop: "-2vh"}}/>
                            </div>
                        </article>
                    </div>
                </div>
            </div>
        )
    };

    const Face = () => {
        let viewTitle = "";
        let viewContent = "";
        let viewContent2 = "";

        switch (face) {
            case 0:
            case 1:
                viewTitle = "외모관리 꽝!";
                viewContent = "귀차니즘이 너무 심한 건 아니신가요?";
                viewContent2 = "잘생기고 예쁜 외모도 가꿔야 빛이나는 법!";
                break;
            case 2:
            case 3:
                viewTitle = "외모관리 준수!";
                viewContent = "외모관리에 조금 더 신경쓰면 연애시작 어렵지 않을거에요:)";
                break;
            case 4:
            case 5:
                viewTitle = "외모관리 PERFECT!";
                viewContent = "외모관리에 신경을 많이 쓰시는군요!";
                viewContent2 = "이성들이 길가다가 한번쯤 돌아보지 않던가요?";
                break;
            default:
                break;
        }

        return (
            <div className="face">
                <div className="title">
                    &nbsp;{viewTitle}&nbsp;
                </div>
                <div className="content">
                    {viewContent}
                    <br/>
                    {viewContent2}
                </div>
            </div>
        )
    };

    const Know = () => {
        let viewTitle = "";
        let viewContent = "";

        switch (know) {
            case 0:
            case 1:
                viewTitle = "연애 지식 꽝!";
                viewContent = "매력적인 사람이 되기 위해서는 공부가 필요해요.";
                break;
            case 2:
            case 3:
                viewTitle = "연애 지식 준수!";
                viewContent = "연애에 조금 더 노력을 기울이면 좋은 애인이 되실 수 있을거에요:)";
                break;
            case 4:
            case 5:
                viewTitle = "연애 지식 PERFECT!";
                viewContent = "행복한 데이트를 위해 노력하는 지적인 당신, 최고에요!";
                break;
            default:
                break;
        }

        return (
            <div className="know">
                <div className="title">
                    &nbsp;{viewTitle}&nbsp;
                </div>
                <div className="content">
                    {viewContent}
                </div>
            </div>
        )
    };

    const Attitude = () => {
        let viewTitle = "";
        let viewContent = "";
        let viewContent2 = "";

        switch (attitude) {
            case 0:
                viewTitle = "연애준비 꽝!";
                viewContent = "연애에서 가장 중요한 건 연애에 대한 자세랍니다. 외모가 아무리 뛰어나도 말을 아무리 잘해도 내가 상대방을 어떻게 즐겁게 해줄 수 있는지에 대해 신경쓰지 않으면 좋은 연애를 하기 어렵습니다. 좋은 연애를 3달내에 하기 위해서는 연애 마인드부터 바꾸셔야할 것 같아요.";
                break;
            case 1:
            case 2:
                viewTitle = "연애준비 준수!";
                viewContent = "즐거운 연애를 하기 위해서 어떻게 해야하는지 코칭이 필요한 상태입니다.";
                break;
            case 3:
            case 4:
                viewTitle = "연애준비 NICE!";
                viewContent = "연애에 대한 기본적인 자세를 갖추고 계시네요.";
                viewContent2 = "더 매력적인 사람이 되기 위한 코칭을 받아보세요:)";
                break;
            case 5:
                viewTitle = "연애준비 PERFECT!";
                viewContent = "함께 즐거운 방법에 대해서 잘 알고 있는 매력적인 당신, 멋집니다!";
                break;
            default:
                break;
        }

        return (
            <div className="know">
                <div className="title">
                    &nbsp;{viewTitle}&nbsp;
                </div>
                <div className="content">
                    {viewContent}
                    <br/>
                    {viewContent2}
                </div>
            </div>
        )
    };

    const Result = () => {
        let viewTitle = "";
        let viewContent = "";

        if (result >= -30 && result < 3) {
            viewTitle = "기분나쁘면 지는 거!";
            viewContent = "포데이트의 연애코칭을 통해 어떻게하면 행복한 연애를 할 수 있는지 배우시면 분명 3달안에 연애하시게 될 거에요 화이팅 :)";
        } else if (result >= 3 && result < 30) {
            viewTitle = "포기하지 마세요!";
            viewContent = "포데이트의 연애코칭을 통해 어떻게하면 행복한 연애를 할 수 있는지 배우시면 분명 3달안에 연애하시게 될 거에요 화이팅 :)";
        } else if (result >= 30 && result < 60) {
            viewTitle = "좋은 분이라는게 느껴집니다:)";
            viewContent = "포데이트의 연애코칭을 통해 어떻게하면 행복한 연애를 할 수 있는지 팁을 배우시면 분명 3달안에 연애하시게 될 거에요 화이팅 :)";
        } else if (result >= 60 && result < 90) {
            viewTitle = "매력적인 당신, 좋은 연애할 확률 가득합니다!";
            viewContent = "포데이트의 연애코칭을 통해 어떻게하면 행복한 연애를 할 수 있는지 팁을 배우시면 분명 3달안에 연애하시게 될 거에요 화이팅 :)";
        } else if (result >= 90 && result < 114) {
            viewTitle = "애인없는 것만 빼면 완벽한 당신";
            viewContent = "포데이트의 연애코칭을 통해 어떻게하면 행복한 연애를 할 수 있는지 약간의 팁을 배우시면 3달이 아니라 한달안에 연애하실 수 있을거에요";
        } else if (result >= 114) {
            viewTitle = "왜 애인이 없는지 이해할 수 없네요!";
            viewContent = "포데이트의 연애코칭을 받으면 당장 연애 시작 가능하신 분이시네요.";
        }

        return (
            <div className="result">
                <div className="title">
                    <span>{viewTitle}</span>
                </div>
                <div className="content">
                    {viewContent}
                </div>
            </div>
        )
    };

    const start = () => {
        setIsStart(false);
        setIsSurvey(true);
    };

    const no = () => {
        UiPageList[step].choice = 0;

        if (step === 14) {
            setIsSurvey(false);
            setIsResult(true);
            setIsLoading(true);
            calculate();

            if (window.fordate) {
                window.fordate.setMessage(JSON.stringify({
                    name: "survey_banner",
                    link: "",
                    type: "end",
                }));
            }

            setTimeout(() => {
                setIsLoading(false);
            }, 2000);

            return;
        }

        nextStep();
    };

    const yes = () => {
        UiPageList[step].choice = 1;

        if (step === 14) {
            setIsSurvey(false);
            setIsResult(true);
            setIsLoading(true);
            calculate();

            if (window.fordate) {
                window.fordate.setMessage(JSON.stringify({
                    name: "survey_banner",
                    link: "",
                    type: "end",
                }));
            }

            setTimeout(() => {
                setIsLoading(false);
            }, 2000);

            return;
        }

        nextStep();
    };

    const nextStep = () => {
        document.getElementById(`nav-${step + 1}`).checked = true;
        setStep(step + 1);
    };

    const calculate = () => {
        const faceCnt = UiPageList.filter(data => data.type === 1 && data.choice === 1).length;
        const knowCnt = UiPageList.filter(data => data.type === 2 && data.choice === 1).length;
        const attitudeCnt = UiPageList.filter(data => data.type === 3 && data.choice === 1).length;

        setFace(faceCnt);
        setKnow(knowCnt);
        setAttitude(attitudeCnt);
        setResult(((faceCnt + 1) * (knowCnt + 1) * attitudeCnt) - 30);
    };

    const redo = () => {
        window.location.reload();
    };

    const link = () => {
        window.location.href = "https://form.fordate.org";
    };

    const Modal = () => {
        if (!window.fordate) {
            alert("링크가 복사되었습니다.");
        } else {
            window.fordate.setMessage(JSON.stringify({
                name: "survey_banner",
                link: "https://survey.fordate.org",
                type: "share",
            }));
        }
    };

    new Clipboard('.share-btn');

    return (
        <>
            {
                isStart && <Start/>
            }
            {
                isSurvey && (
                    <div className="survey">
                        {
                            UiPageList.map((data, index) => {
                                return <input key={index} type="radio" name="choice" id={`nav-${index}`}
                                              defaultChecked={index === 0 && true}/>
                            })
                        }

                        <div id="app">
                            <nav className="ui-nav">
                                <div className="ui-bg">
                                    <div className="ui-cutout"/>
                                    <div className="ui-dot"/>
                                </div>

                                <div className="ui-label yes" onClick={yes}>
                                  <span className="ui-icon">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="96.31" height="101.04"
                                         viewBox="0 0 96.31 101.04">
                                      <defs>예</defs>
                                      <path id="o" className="cls-1"
                                            d="M2052.86,3922.61a43.211,43.211,0,0,0,15.61-13.16,31.692,31.692,0,0,0,6.3-9.59,45.927,45.927,0,0,0,2.94-11.41,135.163,135.163,0,0,0,.98-13.79,54.859,54.859,0,0,0-1.54-13.93,39.821,39.821,0,0,0-4.34-10.85,39.142,39.142,0,0,0-6.72-8.4,54.222,54.222,0,0,0-8.61-6.65q-4.7-2.94-10.01-5.6a48.625,48.625,0,0,0-15.26-2.87,53.684,53.684,0,0,0-15.26,1.75,50.027,50.027,0,0,0-14,6.09,44.2,44.2,0,0,0-11.34,10.15,56.981,56.981,0,0,0-6.3,14.14,100.346,100.346,0,0,0-2.94,14.98q0,6.57.35,12.81a28.456,28.456,0,0,0,2.87,11.27,49.5,49.5,0,0,0,8.33,12.25,53.761,53.761,0,0,0,11.41,9.38,59.181,59.181,0,0,0,13.3,6.02,47.276,47.276,0,0,0,14,2.17A44.381,44.381,0,0,0,2052.86,3922.61Zm-0.84-39.83a27.946,27.946,0,0,1-1.19,7.77l-0.56.28a1.363,1.363,0,0,0-.42,1.82l-0.84,2.1a20.41,20.41,0,0,1-2.31,3.5,15.648,15.648,0,0,1-2.73,2.52c-1.12.46-2.22,0.93-3.29,1.4s-2.12.88-3.15,1.26a20.5,20.5,0,0,1-2.45.14h-2.87a21.016,21.016,0,0,1-16.73-7.42,24.354,24.354,0,0,1-4.41-7.7,36.706,36.706,0,0,1-1.96-9.1,34.2,34.2,0,0,1,1.19-10.85,29.591,29.591,0,0,1,4.48-9.59,20.779,20.779,0,0,1,7.56-6.51,18.214,18.214,0,0,1,10.57-1.61,20.869,20.869,0,0,1,7.98,3.08,22.186,22.186,0,0,1,5.74,5.53,26.907,26.907,0,0,1,3.71,7.21,36.1,36.1,0,0,1,1.75,7.84C2052.09,3877.25,2052.07,3880.02,2052.02,3882.78Zm-47.11-41.23q7.98-2.25,16.1-4.9a83.564,83.564,0,0,1,16.52-3.64,15.242,15.242,0,0,0,2.52.42q-9.1,2.655-17.99,5.18t-18.13,5.04a14.156,14.156,0,0,0-2.59.84c-0.89.37-1.84,0.74-2.87,1.12,0.47-.47.98-0.96,1.54-1.47s1.12-1.01,1.68-1.47c1.21-.47,2.29-0.84,3.22-1.12h0Zm51.38,72.52a1.247,1.247,0,0,0-.63-1.4,1.349,1.349,0,0,0-1.61.28,17.162,17.162,0,0,1-4.41,2.59,46.768,46.768,0,0,1-4.97,1.61c1.87-1.22,3.73-2.31,5.6-3.29s3.87-1.99,6.02-3.01a9.523,9.523,0,0,1,1.89-.7,19.144,19.144,0,0,0,2.1-.7,8.218,8.218,0,0,0,1.89-1.05,3.028,3.028,0,0,0,1.12-1.61,1.485,1.485,0,0,0-1.68-1.68,11.1,11.1,0,0,0-2.45.77q-2.025.765-4.34,1.82c-1.54.7-3.01,1.37-4.41,2.03s-2.29,1.07-2.66,1.26a56.935,56.935,0,0,1-5.81,2.38q-2.865.975-5.81,1.82,3.915-1.965,7.77-3.99c2.57-1.36,5.2-2.69,7.91-3.99a4.357,4.357,0,0,0,.7-0.84l2.24-.84a1.241,1.241,0,0,0,1.54.84,24.274,24.274,0,0,0,4.2-1.89q2.1-1.2,4.2-2.59l2.94-.84a16.138,16.138,0,0,1-1.75,3.15c-0.7.98-1.42,1.98-2.17,3.01a50.82,50.82,0,0,1-7.42,6.86h0Zm-31.64-70.91c1.4-.24,2.85-0.54,4.34-0.91a14.464,14.464,0,0,0-4.34,2.8,0.927,0.927,0,0,0-.28.7,19.714,19.714,0,0,0-2.45.7,12.722,12.722,0,0,0-2.17.98l0.84-.7a1.777,1.777,0,0,0,.56-1.26c0-.19-0.05-0.28-0.14-0.28a1.3,1.3,0,0,0-1.54-1.12q-6.3,1.53-12.39,3.64a63.777,63.777,0,0,1-12.39,2.94l0.7-1.12a27.816,27.816,0,0,0,4.76-1.61,43.046,43.046,0,0,1,4.62-1.75l14.28-3.64a1.456,1.456,0,0,0,1.26,1.12C2021.8,3843.55,2023.25,3843.39,2024.65,3843.16Zm-5.11,69.23q4.275-1.68,8.61-3.08a13.125,13.125,0,0,1,1.4.07c0.47,0.04.98,0.07,1.54,0.07-2.61,1.3-5.16,2.61-7.63,3.92s-4.97,2.52-7.49,3.64a0.574,0.574,0,0,1-.42.14v0.14l-0.56.42a12.326,12.326,0,0,1-1.75-.77c-0.61-.33-1.19-0.63-1.75-0.91A84.2,84.2,0,0,1,2019.54,3912.39Zm34.93-73.08q-5.325,1.395-10.85,2.66a105.088,105.088,0,0,0-10.85,3.08l-0.56.28c-0.47,0-1-.03-1.61-0.07a6.758,6.758,0,0,0-1.75.07,43.143,43.143,0,0,1,7.07-2.73c2.66-.8,4.78-1.47,6.37-2.03a35.742,35.742,0,0,0,4.13-1.68,29.609,29.609,0,0,1,4.27-1.68Zm5.39,58.52a41.067,41.067,0,0,1,8.19-2.24,23.736,23.736,0,0,1-1.96,1.75c-0.65.51-1.35,1.05-2.1,1.61l-1.96.56q-3.645,1.395-7,2.8t-7,2.66a18.235,18.235,0,0,0,3.92-4.06Q2055.865,3899.365,2059.86,3897.83Zm-60.41-28.07c-1.77.51-3.55,1-5.32,1.47q2.385-1.41,4.69-3.01a10.559,10.559,0,0,0,3.57-4.41,1.188,1.188,0,0,0-.7-1.26c1.12-.47,2.22-0.94,3.29-1.4s2.03-.94,2.87-1.4a22.317,22.317,0,0,0-1.82,4.06c-0.47,1.4-.93,2.89-1.4,4.48Q2002.11,3868.98,1999.45,3869.76Zm73.36,6.37a25.8,25.8,0,0,0-7.63,2.66c-2.47,1.3-4.97,2.52-7.49,3.64a7.467,7.467,0,0,0,.14-1.4v-1.4a38.961,38.961,0,0,0,7.49-3.01,28.9,28.9,0,0,1,7.49-2.73v2.24Zm-63.84-21.7a3.786,3.786,0,0,1-.63-0.07,1.4,1.4,0,0,0-.77.07,16.236,16.236,0,0,0-4.41.56,38.7,38.7,0,0,0-4.13,1.4q2.655-1.545,5.39-2.87t5.53-2.45c1.31-.38,2.59-0.75,3.85-1.12a36.8,36.8,0,0,0,3.85-1.4,23.291,23.291,0,0,0-7.14,6.72,1.561,1.561,0,0,0-1.54-.84h0Zm59.36,0.28a16.69,16.69,0,0,0-5.6.98c-1.87.65-3.73,1.21-5.6,1.68,0.84-.47,1.73-0.91,2.66-1.33s1.84-.87,2.73-1.33a19.481,19.481,0,0,0,2.38-1.47,4.18,4.18,0,0,0,1.47-1.89,1.508,1.508,0,0,0-.42-1.12c-0.47-.56-1.42-0.77-2.87-0.63a24.921,24.921,0,0,0-4.76.98,50.139,50.139,0,0,0-5.11,1.82,20.772,20.772,0,0,0-3.92,2.03,3.959,3.959,0,0,0-.98-1.12,41.394,41.394,0,0,1,7.7-2.66,47.385,47.385,0,0,1,7.7-1.26,1.194,1.194,0,0,0,1.26-.84c0.75,1.02,1.42,2.03,2.03,3.01a29.5,29.5,0,0,1,1.75,3.29,0.535,0.535,0,0,0-.42-0.14h0Zm-73.99,19.11c2.1-.52,4.18-1.05,6.23-1.61a68.238,68.238,0,0,1-6.44,3.64,31.645,31.645,0,0,0-6.02,3.78,14.468,14.468,0,0,1-.14-1.96v-1.96Q1991.195,3874.585,1994.34,3873.82Zm12.32,32.2a32.528,32.528,0,0,1,5.67-1.89q-2.385,1.815-4.62,3.36c-1.49,1.02-2.99,2.14-4.48,3.36-0.65-.56-1.31-1.12-1.96-1.68a20.122,20.122,0,0,1-1.96-1.96h0.56a0.9,0.9,0,0,0,.98.42A22.015,22.015,0,0,0,2006.66,3906.02Zm23.59,14.98q-1.815-.075-3.78-0.21c2.33-.75,4.67-1.43,7-2.03s4.62-1.29,6.86-2.03c-0.47.37-.93,0.77-1.4,1.19s-0.93.86-1.4,1.33a1.188,1.188,0,0,0-.42,1.68,8.157,8.157,0,0,1-1.54.14h-1.54C2032.72,3921.07,2031.46,3921.04,2030.25,3921Zm-36.82-54.53a25.841,25.841,0,0,1,4.62-1.26,17.479,17.479,0,0,1-4.62,3.64c-1.96,1.12-3.69,2.14-5.18,3.08,0.09-.66.16-1.31,0.21-1.96a9.493,9.493,0,0,1,.35-1.96Q1991.2,3867.305,1993.43,3866.47Zm69.93-4.34a55.737,55.737,0,0,1-7.63,2.8v-0.28a39.331,39.331,0,0,0,3.85-1.75c1.35-.7,2.61-1.36,3.78-1.96s2.17-1.15,3.01-1.61a4.5,4.5,0,0,1,1.82-.7,1.591,1.591,0,0,0,1.4-1.4v-0.28l0.14-.14c0.28,0.65.54,1.3,0.77,1.96s0.44,1.35.63,2.1A14.807,14.807,0,0,0,2063.36,3862.13Zm-1.33-15.4a56.008,56.008,0,0,0-15.96,4.48l-1.4-.84a37.673,37.673,0,0,0,7.63-2.52,43.174,43.174,0,0,1,7.77-2.66Zm-59.64,30.38a18.629,18.629,0,0,0-6.02,1.82,26.985,26.985,0,0,1-5.74,2.1,34.813,34.813,0,0,1,6.51-3.78,30.812,30.812,0,0,0,6.51-3.92,6.93,6.93,0,0,0-.28,1.96,17.748,17.748,0,0,1-.14,2.1,2.063,2.063,0,0,0-.84-0.28h0Zm6.23,25.06c-1.17.46-2.4,0.93-3.71,1.4a12.081,12.081,0,0,0,2.94-2.66,1.547,1.547,0,0,0-.28-2.38,2.7,2.7,0,0,0-1.4-.42,6.239,6.239,0,0,0,1.96-2.52,23.441,23.441,0,0,0,4.2,5.6A15.582,15.582,0,0,0,2008.62,3902.17Zm-18.69-39.48,2.52-1.12c2.33-.84,4.67-1.64,7-2.38a59.254,59.254,0,0,1,7.14-1.82,27.038,27.038,0,0,1-8.26,3.43,50.45,50.45,0,0,0-8.68,2.87Zm75.81,23.1a37.18,37.18,0,0,0,6.79-3.92l-0.14,2.8q-2.235.69-6.3,2.24-4.065,1.53-7.98,2.66Q2061.755,3887.605,2065.74,3885.79Zm-71.82-2.73c1.35-.42,2.64-0.87,3.85-1.33a3.68,3.68,0,0,1-.84.56q-1.965,1.395-3.85,2.66t-3.85,2.8a23.285,23.285,0,0,1-.84-5.04h0.14c0,0.93.61,1.35,1.82,1.26A31.307,31.307,0,0,0,1993.92,3883.06Zm33.81,32.48q4.2-1.89,8.54-3.57c-2.15,1.02-4.22,2.05-6.23,3.08s-4.04,2.05-6.09,3.08a1.886,1.886,0,0,0-1.12,1.82v0.14c-0.65-.19-1.31-0.35-1.96-0.49s-1.26-.31-1.82-0.49Q2023.535,3917.43,2027.73,3915.54Zm23.24-59.15a15.816,15.816,0,0,1,3.71-1.82,40.7,40.7,0,0,1,4.69-1.4q-2.1,1.395-4.06,2.87a10.732,10.732,0,0,0-2.66,2.59Zm-57.82-2.94c1.31-.19,2.64-0.38,3.99-0.56a35.6,35.6,0,0,0,4.13-.84l-6.3,3.36-3.36,1.4Zm64.26,32.2q3.36-1.41,6.79-3.22a43.441,43.441,0,0,1,6.79-2.94,64.411,64.411,0,0,1-6.37,3.64c-2.57,1.3-5.06,2.56-7.49,3.78Zm-15.19-40.46c1.54-.38,3.1-0.8,4.69-1.26-1.03.65-2.03,1.28-3.01,1.89s-1.98,1.28-3.01,2.03a18.5,18.5,0,0,0-1.75-.77c-0.61-.24-1.14-0.45-1.61-0.63C2039.12,3845.98,2040.68,3845.56,2042.22,3845.19Zm16.87-2.66q-2.235.69-4.83,1.68c-1.73.65-3.38,1.26-4.97,1.82q1.965-1.125,3.78-2.31c1.21-.8,2.29-1.57,3.22-2.31l0.42-.7Zm11.76,49.84c-1.21.18-2.36,0.35-3.43,0.49a20.247,20.247,0,0,0-3.43.77c1.4-.84,2.78-1.64,4.13-2.38a36.579,36.579,0,0,0,3.57-2.24Zm-55.93,15.05c-1.35.42-2.68,0.86-3.99,1.33,0.93-.75,1.8-1.47,2.59-2.17s1.56-1.43,2.31-2.17a12.468,12.468,0,0,1,1.33.91,5.748,5.748,0,0,0,1.33.77A32.352,32.352,0,0,1,2014.92,3907.42Zm-4.41,5.74a4.9,4.9,0,0,1-1.54,1.33v0.14c-0.19,0-.28.04-0.28,0.14l-2.38-1.68a31.67,31.67,0,0,1,3.22-1.26c1.12-.38,2.24-0.75,3.36-1.12C2012.14,3911.45,2011.35,3912.27,2010.51,3913.16Zm-19.11-22.19a10.586,10.586,0,0,0,1.33-.42,6.678,6.678,0,0,1-1.26.7,1.21,1.21,0,0,0-.56.98v0.56a1.438,1.438,0,0,0,1.4,1.4,7.652,7.652,0,0,0,4.06-.56l-3.22,2.66c-0.65.93-.51,1.58,0.42,1.96l-0.28.28-0.14.14a22.467,22.467,0,0,1-1.68-3.64c-0.47-1.31-.93-2.62-1.4-3.92A6.307,6.307,0,0,0,1991.4,3890.97Zm64.47,1.82c1.31-.28,2.66-0.61,4.06-0.98s2.8-.8,4.2-1.26q-2.385,1.11-4.69,2.31-2.31,1.185-4.41,2.17Zm-38.43-57.89q-3.855,1.185-7.63,2.31a34.968,34.968,0,0,1,7.56-3.01,50.982,50.982,0,0,1,7.98-1.47C2022.64,3833.38,2020.01,3834.1,2017.44,3834.9Zm49.49,31.99a49.192,49.192,0,0,1-5.46,1.82q2.805-1.125,5.53-2.24a14.322,14.322,0,0,0,4.69-3.08,7.555,7.555,0,0,1,.21.77,3.671,3.671,0,0,1,.07.77Q2069.735,3865.77,2066.93,3866.89Zm-6.16,5.11c1.03-.24,2.1-0.54,3.22-0.91-1.12.56-2.33,1.21-3.64,1.96a13.767,13.767,0,0,0-1.26.84c-0.37.28-.75,0.56-1.12,0.84a8.317,8.317,0,0,0-.07-1.12q-0.075-.57-0.21-1.26A14.058,14.058,0,0,0,2060.77,3872Zm-6.86-11.13a37.472,37.472,0,0,0,3.71-.63c0.98-.24,1.98-0.49,3.01-0.77-0.93.56-1.89,1.09-2.87,1.61a15.077,15.077,0,0,1-3.01,1.19Zm14.14,11.55q-2.235.9-4.62,1.89,2.385-1.125,4.69-2.31a34.438,34.438,0,0,0,4.41-2.73,4.762,4.762,0,0,0,.07.84,4.762,4.762,0,0,1,.07.84A30.3,30.3,0,0,0,2068.05,3872.42Zm-64.54,10.15a0.773,0.773,0,0,0-.98.14l-4.9,2.66a42.384,42.384,0,0,0,3.36-2.59,10,10,0,0,0,2.24-2.59Zm57.68-16.66a30.085,30.085,0,0,1,4.48-1.68q-2.385,1.11-4.69,2.03a35.8,35.8,0,0,0-4.13,1.89,0.841,0.841,0,0,1-.14-0.56A32.471,32.471,0,0,0,2061.19,3865.91Zm-55.44,25.06c-0.75.46-1.54,0.91-2.38,1.33s-1.63.86-2.38,1.33c0.75-.56,1.49-1.12,2.24-1.68a21.806,21.806,0,0,0,2.24-1.96Zm-11.2,9.94a5.539,5.539,0,0,0,2.59-.42c0.98-.38,2.03-0.84,3.15-1.4-0.93.56-1.8,1.07-2.59,1.54a24.4,24.4,0,0,0-2.31,1.54Zm9.8-14.14-1.54.42a6.581,6.581,0,0,0,1.26-1.68Zm-6.16,17.92a0.942,0.942,0,0,0-.7.28l-0.42-.42a8.8,8.8,0,0,0,2.38-.7Zm46.76-69.86a0.823,0.823,0,0,0,.56.14l-3.22.84Zm-22.12,73.36,0.14-.14a0.127,0.127,0,0,0,.14.14h-0.28Z"
                                            transform="translate(-1982.38 -3826.34)"/>
                                    </svg>
                                  </span>
                                </div>

                                <div className="ui-label no" onClick={no}>
                                  <span className="ui-icon">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="94.31" height="97.66"
                                         viewBox="0 0 94.31 97.66">
                                      <defs>아니요</defs>
                                      <path id="x" className="cls-1"
                                            d="M2751.59,3916.91a2.864,2.864,0,0,0,1.26-1.96q4.485-6.855,8.47-12.32a64.1,64.1,0,0,0,6.93-12.18q2.52,3.645,4.62,6.93t4.06,6.3q1.965,3.015,3.99,5.95a57.452,57.452,0,0,0,4.69,5.88,3.229,3.229,0,0,0,.7,2.03,2.483,2.483,0,0,0,2.1.91h24.22a2.355,2.355,0,0,0,1.61-.56,2.693,2.693,0,0,0,.84-1.4,3.179,3.179,0,0,0-.07-1.75,3.512,3.512,0,0,0-.84-1.47,2.663,2.663,0,0,0-.56-3.08l-22.4-30.38a15.648,15.648,0,0,1-1.26-1.54c-0.56-.75-1.19-1.61-1.89-2.59s-1.38-1.98-2.03-3.01a22.054,22.054,0,0,1-1.54-2.8q7.14-9.66,13.3-19.18t12.46-19.74a3.616,3.616,0,0,0,.7-2.94,2.322,2.322,0,0,0,1.33-1.33,2.881,2.881,0,0,0,.14-1.75,2.974,2.974,0,0,0-1.05-1.54,3.375,3.375,0,0,0-2.24-.7h-18.06a3.419,3.419,0,0,0-2.03-.7,2.858,2.858,0,0,0-1.89.7,3.822,3.822,0,0,0-.7.84l-0.42.42a66.357,66.357,0,0,0-4.13,5.88c-1.35,2.15-2.71,4.34-4.06,6.58s-2.73,4.43-4.13,6.58-2.8,4.11-4.2,5.88q-3.645-5.175-7.84-11.34a83.573,83.573,0,0,1-6.86-11.9,4.6,4.6,0,0,0-.84-2.17,2.706,2.706,0,0,0-1.33-.84,7.618,7.618,0,0,0-1.96-.21,15.214,15.214,0,0,1-2.73-.28c-3.73,0-7.33.07-10.78,0.21a69.442,69.442,0,0,1-11.06-.49,2.142,2.142,0,0,0-1.75.77,3.4,3.4,0,0,0-.77,1.68,3.442,3.442,0,0,0,.28,1.89,2.678,2.678,0,0,0,1.26,1.4q2.94,5.745,6.44,11.27t6.93,10.57q3.435,5.04,6.44,9.52a65.606,65.606,0,0,1,4.69,7.98,3.3,3.3,0,0,0,.7,1.4,0.574,0.574,0,0,0,.14.42q-7.56,11.895-14.98,23.52t-14.14,22.68a1.69,1.69,0,0,0-.14,2.17,2.594,2.594,0,0,0,2.52,1.33,57.544,57.544,0,0,0,11.62.49c3.83-.23,7.37-0.35,10.64-0.35a3.2,3.2,0,0,0,2.17.91,3.359,3.359,0,0,0,2.45-.91,10.879,10.879,0,0,1,.98-1.68h0Zm43.82-15.4a3.9,3.9,0,0,0,.84-3.64c-0.37-1.21-1.03-1.54-1.96-.98l-2.24,1.4a4.81,4.81,0,0,0,1.26-4.06,1.415,1.415,0,0,0-1.68-1.26,7.451,7.451,0,0,0-1.4.42c-0.47.19-.93,0.37-1.4,0.56a1.238,1.238,0,0,0,.35-0.56,1.238,1.238,0,0,1,.35-0.56,2.773,2.773,0,0,0,.42-1.68c-0.28-1.4-1.21-2.01-2.8-1.82a3.393,3.393,0,0,0,.14-2.52,1.629,1.629,0,0,0-1.68-1.12,16.263,16.263,0,0,0-2.17.56c-0.89.28-1.82,0.63-2.8,1.05s-1.98.91-3.01,1.47a22.024,22.024,0,0,0-2.66,1.68l-1.54-2.66h0.42a7.384,7.384,0,0,0,3.5-1.47,7.384,7.384,0,0,1,3.5-1.47,1.492,1.492,0,0,0,.91-1.61,1.6,1.6,0,0,0-1.33-1.19,5.42,5.42,0,0,0,1.26-3.5,1.7,1.7,0,0,0-1.26-1.26,6.051,6.051,0,0,0-2.66.28c0.47-.56.91-1.14,1.33-1.75a6.224,6.224,0,0,0,.91-2.03v-0.28q4.9,7.275,9.45,13.86t8.75,12.46a10.348,10.348,0,0,0-2.8,1.68h0Zm-39.76-30.24c0.19-.09.35-0.16,0.49-0.21a1.408,1.408,0,0,0,.49-0.35,3.6,3.6,0,0,0,2.38-.28,18.55,18.55,0,0,0,1.96-.98,18.773,18.773,0,0,0,3.99-2.24,24.639,24.639,0,0,1,4.41-2.52,29.634,29.634,0,0,1-5.53,5.25,17.291,17.291,0,0,0-4.97,5.53,0.532,0.532,0,0,1-.07.35,0.366,0.366,0,0,0,.07.35c-1.12,0-2.22.05-3.29,0.14s-2.17.23-3.29,0.42Zm-4.97-41.51c0.42,0.79.86,1.56,1.33,2.31a18.59,18.59,0,0,0-2.8,1.26c-0.84.47-1.68,0.98-2.52,1.54,0.28-.47.54-0.89,0.77-1.26a8.221,8.221,0,0,0,.63-1.26,1.647,1.647,0,0,0-1.26-1.68q-1.965-.42-4.69,1.4t-5.53,3.36l-0.14-.14a52.5,52.5,0,0,1,4.2-3.71,28.664,28.664,0,0,0,3.36-3.01,1.719,1.719,0,0,0,.42-0.98,23.646,23.646,0,0,1,2.52-.14h2.38C2749.82,3828.2,2750.26,3828.97,2750.68,3829.76Zm22.89,41.58c-1.03.89-2.1,1.77-3.22,2.66s-2.19,1.8-3.22,2.73a11.2,11.2,0,0,0-2.38,2.94,0.5,0.5,0,0,0-.07.42,0.909,0.909,0,0,1,.07.42v-0.14a6.9,6.9,0,0,0-3.22-.63,27.345,27.345,0,0,0-3.36.35l2.24-1.12a1.258,1.258,0,0,0,.7-1.82,12.392,12.392,0,0,0,3.92-1.82c1.21-.84,2.43-1.73,3.64-2.66s2.43-1.8,3.64-2.59a11.159,11.159,0,0,1,3.78-1.61A12.927,12.927,0,0,1,2773.57,3871.34Zm31.36-42.91-6.16,10.22a1.635,1.635,0,0,0-1.54-.7l-4.62.84a15.185,15.185,0,0,0,4.62-2.8,1.831,1.831,0,0,0,.49-1.33,1.11,1.11,0,0,0-.63-0.91,8.076,8.076,0,0,0,4.48-2.8c0.56-1.03.23-1.73-.98-2.1l-2.94-.42h7.28Zm-24.57,37.31a7.4,7.4,0,0,0-.77,1.19,0.282,0.282,0,0,0-.07-0.21,0.532,0.532,0,0,1-.07-0.35,0.447,0.447,0,0,1-.28-0.21,0.389,0.389,0,0,0-.14-0.21,14.064,14.064,0,0,0,1.96-1.75,2.45,2.45,0,0,0,.7-2.03l-0.28-.56a7.143,7.143,0,0,0,2.45-1.4,2.417,2.417,0,0,0,.63-2.38,1.268,1.268,0,0,0-.84-0.98,9.491,9.491,0,0,0-4.55-.28c-1.45.28-2.96,0.61-4.55,0.98a80.6,80.6,0,0,1,8.4-2.66c2.89-.75,5.04-1.35,6.44-1.82q-2.94,4.335-4.76,6.86c-1.21,1.68-2.29,3.08-3.22,4.2A13.29,13.29,0,0,1,2780.36,3865.74Zm-3.85-15.47a28.74,28.74,0,0,1,6.65-.91,24.7,24.7,0,0,0,6.65-1.05,13.106,13.106,0,0,0,2.1-.84,9.709,9.709,0,0,0,1.96-1.26l-3.78,5.74a0.909,0.909,0,0,0-.07-0.42,0.909,0.909,0,0,1-.07-0.42c0-.09-0.02-0.14-0.07-0.14s-0.07-.05-0.07-0.14a1.5,1.5,0,0,0-1.4-.7,117.165,117.165,0,0,1-12.74,1.26Zm-41.16,53.2a72.612,72.612,0,0,0,7.63-2.24,30.308,30.308,0,0,1,7.63-1.68,37.5,37.5,0,0,1-8.05,3.5q-4.83,1.545-9.17,3.08Zm7.98-12.46h0.14l1.26-.42a43.309,43.309,0,0,0,7.77-2.17,27.442,27.442,0,0,1,7.91-1.75,40.986,40.986,0,0,1-7,3.5,33.009,33.009,0,0,0-5.74,1.12q-2.94.84-5.6,1.68Zm21.84-5.18v-0.14a1.647,1.647,0,0,0-1.26-1.68h-0.56a5.508,5.508,0,0,0,2.24-2.1,1.615,1.615,0,0,0-.14-0.7,1.274,1.274,0,0,0,.98.14,22.919,22.919,0,0,0,4.48-2.87,24.576,24.576,0,0,1,4.76-3.01q-1.545,1.68-3.64,3.57a17.386,17.386,0,0,0-3.08,3.43,3.6,3.6,0,0,0-2.66.98Zm-2.66,4.2a55.452,55.452,0,0,0-8.12,7q-0.84-.135-1.68-0.21a6.764,6.764,0,0,0-1.68.07,46.271,46.271,0,0,0,4.83-2.73c1.35-.89,2.03-1.7,2.03-2.45a0.909,0.909,0,0,0-.07-0.42,0.581,0.581,0,0,1-.07-0.28c1.03-.47,2.17-1.03,3.43-1.68a12.017,12.017,0,0,0,3.01-2.1,10.156,10.156,0,0,1-.7,1.4c-0.28.47-.56,0.93-0.84,1.4h-0.14Zm-5.53-29.61c1.07-.79,2.19-1.59,3.36-2.38s2.26-1.56,3.29-2.31a10.756,10.756,0,0,0,2.52-2.52,6.783,6.783,0,0,0,1.26,1.82c-2.05,1.21-4.27,2.5-6.65,3.85a35.477,35.477,0,0,0-6.23,4.41l-0.28-.28A14.718,14.718,0,0,1,2756.98,3860.42Zm0.77,22.75c-2.05.75-4.08,1.42-6.09,2.03s-3.99,1.28-5.95,2.03l2.1-3.22a12.127,12.127,0,0,0,5.81-.35,40.107,40.107,0,0,1,6.23-1.19Zm-11.9-32.76a21.659,21.659,0,0,0,5.53-2.94,16.564,16.564,0,0,1,5.39-2.66,13.334,13.334,0,0,1-4.69,3.78,19.559,19.559,0,0,0-4.97,3.5Zm-17.36,63.14,2.1-3.08a48.359,48.359,0,0,0,6.3-1.82q3.075-1.125,6.3-1.96c-1.12.56-2.33,1.1-3.64,1.61s-2.57,1.03-3.78,1.54a17.465,17.465,0,0,0-3.22,1.75,8.514,8.514,0,0,0-2.24,2.24Zm57.82-21a4.874,4.874,0,0,1-.84.98l-5.18,5.18a5.715,5.715,0,0,0-.84-1.12,3.3,3.3,0,0,1-.7-1.12,32.148,32.148,0,0,1,7.56-3.92h0Zm-36.54,12.04a0.9,0.9,0,0,0-.42-1.26l2.24-1.12a1.017,1.017,0,0,0,.91.42,1.542,1.542,0,0,0,1.19-.7,20.04,20.04,0,0,1,4.62-4.76l-5.18,7.84a1.718,1.718,0,0,0-1.54-.98,14.531,14.531,0,0,0-1.82.56h0Zm18.06-42.21a43.1,43.1,0,0,0-4.48,2.45,27.291,27.291,0,0,0,2.73-2.24,16.531,16.531,0,0,0,2.17-2.52,7.892,7.892,0,0,0,3.08.49,16.66,16.66,0,0,0,3.01-.42c0.98-.23,1.96-0.47,2.94-0.7a13.111,13.111,0,0,1,3.01-.35,15.978,15.978,0,0,1-4.27,1.4c-1.54.28-2.5,0.47-2.87,0.56l-0.56.42a1.287,1.287,0,0,0-.56-0.14A9.917,9.917,0,0,0,2767.83,3862.38Zm-19.25-22.68a35.722,35.722,0,0,1-6.23,2.87,0.417,0.417,0,0,0,.28-0.14,45.5,45.5,0,0,1,5.67-3.64,45.5,45.5,0,0,0,5.67-3.64,14.618,14.618,0,0,0,.84,1.54A44.636,44.636,0,0,0,2748.58,3839.7Zm33.53,61.39q1.545-.975,3.78-2.45a31.974,31.974,0,0,1,4.06-2.31,11.467,11.467,0,0,1-1.47,1.75l-1.89,1.89a19.725,19.725,0,0,1-1.89,1.68,14.611,14.611,0,0,0-1.33,1.12v0.14Zm-33.04-45.64c1.49-.75,2.92-1.49,4.27-2.24a28.673,28.673,0,0,1,4.41-1.96,46.287,46.287,0,0,1-3.85,3.15c-1.45,1.07-2.68,1.98-3.71,2.73Zm8.96-13.86a14.184,14.184,0,0,0-5.95,2.52,29.745,29.745,0,0,1-5.67,3.22,15.332,15.332,0,0,1,5.46-3.92,20.574,20.574,0,0,0,5.32-3.22Zm-15.61,70.42a5.384,5.384,0,0,1,3.85,0,2.443,2.443,0,0,1,.28,1.12v0.14a38.646,38.646,0,0,1-4.34.42c-1.77.09-3.36,0.14-4.76,0.14A50.729,50.729,0,0,1,2742.42,3912.01Zm29.19-27.72a14.512,14.512,0,0,0,3.29-2.31,7.626,7.626,0,0,1,3.43-1.89,8.377,8.377,0,0,1-2.59,3.01,32.892,32.892,0,0,0-3.01,2.59l-0.28.42Zm-11.55-21.49q2.175-1.05,4.41-2.31c-1.21,1.12-2.5,2.19-3.85,3.22a36.807,36.807,0,0,0-3.71,3.22,5.352,5.352,0,0,0-.98-1.4A19.182,19.182,0,0,1,2760.06,3862.8Zm-25.55-30.31a4.817,4.817,0,0,1,1.61-2.52,10.277,10.277,0,0,0,2.03-2.24h1.47a7.8,7.8,0,0,0,1.47-.14c-0.93.75-1.96,1.59-3.08,2.52s-2.19,1.91-3.22,2.94Zm35.63,35.21a16.3,16.3,0,0,0,2.87-3.85,0.417,0.417,0,0,0,.28.14,4.455,4.455,0,0,0,2.24,0c0.84-.19,1.63-0.37,2.38-0.56a16.562,16.562,0,0,1-2.45,1.26,11.4,11.4,0,0,0-2.31,1.26,1.507,1.507,0,0,0-.7,1.12,23.728,23.728,0,0,0-2.94,1.89c-0.93.7-1.91,1.42-2.94,2.17Q2768.385,3869.45,2770.14,3867.7Zm26.88,39.06a35.119,35.119,0,0,0,3.71-3.71,2.642,2.642,0,0,1,.49.7,2.642,2.642,0,0,0,.49.7,26.37,26.37,0,0,0-4.13,3.01,31.581,31.581,0,0,1-3.99,3.01A21.153,21.153,0,0,1,2797.02,3906.76Zm-16.03-15.75a28.353,28.353,0,0,0-3.64,3.08l-1.12-1.68a9.44,9.44,0,0,1,3.64-1.82,32.135,32.135,0,0,0,3.64-1.26A29.618,29.618,0,0,0,2780.99,3891.01Zm7.7-59.64c1.03,0,2.1-.02,3.22-0.07s2.24-.07,3.36-0.07c-1.4.47-2.75,0.86-4.06,1.19s-2.1.54-2.38,0.63a3.07,3.07,0,0,0-.98.84,4.362,4.362,0,0,0-1.26.14,12.468,12.468,0,0,1,.91-1.33c0.33-.42.68-0.86,1.05-1.33h0.14Zm2.31,76.58c1.26-.75,2.64-1.63,4.13-2.66-1.03,1.03-1.98,2.01-2.87,2.94a28.487,28.487,0,0,0-2.45,2.94,13.767,13.767,0,0,0-.84-1.26,5.054,5.054,0,0,0-.98-0.98A5.177,5.177,0,0,0,2791,3907.95Zm-28.77-60.2a1.711,1.711,0,0,0-1.26-.42,24.431,24.431,0,0,0-5.04,1.82,18.161,18.161,0,0,0,4.06-4.62Zm-22.82,49.28a31.033,31.033,0,0,0,7-1.4,61.517,61.517,0,0,0,6.86-2.66,30.8,30.8,0,0,1-7.14,3.15q-3.915,1.185-7.7,2.31Zm9.38,14.42a2.5,2.5,0,0,0-1.12-1.68,0.417,0.417,0,0,0,.28-0.14c0.37-.37.77-0.75,1.19-1.12a4.641,4.641,0,0,1,1.33-.84,1.518,1.518,0,0,0,.42-0.28,1.518,1.518,0,0,1,.42-0.28l0.56-.28Zm50.33-1.26a12.4,12.4,0,0,0-1.19,1.96,0.574,0.574,0,0,0-.14.42h-3.22c1.12-.75,2.26-1.52,3.43-2.31s1.98-1.38,2.45-1.75C2799.98,3909.07,2799.54,3909.63,2799.12,3910.19Zm9.03,2.38h-5.46q0.975-.555,1.89-1.05a16.031,16.031,0,0,1,2.03-.91Zm-77-84.98c0.56,0,1.17.02,1.82,0.07s1.31,0.07,1.96.07l-2.1,2.24Zm55.58,79.38v0.28a6.01,6.01,0,0,0-.91-1.19,10.07,10.07,0,0,1-.91-1.05,24.555,24.555,0,0,0,4.34-1.54,7.706,7.706,0,0,0-2.52,3.5h0Zm-7.98-60.76a38.351,38.351,0,0,0,4.55,0c1.45-.09,2.96-0.23,4.55-0.42a18.768,18.768,0,0,1-4.76.77c-1.59.05-3.17,0.16-4.76,0.35Zm-35.84-.98a40.6,40.6,0,0,0,5.32-2.38c-0.84.65-1.66,1.26-2.45,1.82a12.18,12.18,0,0,0-2.17,1.96Zm52.08-.56v-0.14a1.485,1.485,0,0,0-1.68-1.68,8.73,8.73,0,0,0,2.03-.77c0.61-.33,1.19-0.63,1.75-0.91Zm-19.32,28.28,2.24-2.52,1.12,1.82a0.581,0.581,0,0,1-.28-0.07,0.909,0.909,0,0,0-.42-0.07,6.5,6.5,0,0,0-2.66.84h0Zm-19.32-15.26c-0.65.56-1.28,1.1-1.89,1.61s-1.19,1.05-1.75,1.61a4.27,4.27,0,0,0-.28-0.49,4.27,4.27,0,0,1-.28-0.49,0.574,0.574,0,0,0,.42-0.14q1.68-.84,3.78-2.1h0Zm25.2-15.96a18.211,18.211,0,0,0,2.17.14h2.31c-0.93.19-1.8,0.33-2.59,0.42a22.864,22.864,0,0,0-2.45.42Zm-17.92,8.26-1.96.98a2.356,2.356,0,0,0,.49-0.84,10.882,10.882,0,0,1,.49-1.12,0.909,0.909,0,0,0-.07-0.42,0.909,0.909,0,0,1-.07-0.42Zm20.16-11.9,0.7-.98q0.705,0.135,1.47.21a9.039,9.039,0,0,0,1.89-.07,36.268,36.268,0,0,1-4.06.84h0Zm-41.3-2.94a17.186,17.186,0,0,1-2.1,1.54,17.186,17.186,0,0,0-2.1,1.54l-0.42-.56Zm33.04,19.04-2.24.84,0.84-1.26a0.9,0.9,0,0,0,.98.42h0.42Zm28.28,54.32,0.42-.7a0.785,0.785,0,0,1,.28.42Zm-58.1.14v0.42a0.909,0.909,0,0,1-.42-0.07,0.909,0.909,0,0,0-.42-0.07Zm45.08-80.22h1.82a7.03,7.03,0,0,0-1.05.07,6.031,6.031,0,0,1-.91.07Zm-40.46,51.52a0.127,0.127,0,0,1,.14-0.14,0.581,0.581,0,0,0,.28-0.07,0.581,0.581,0,0,1,.28-0.07,2.35,2.35,0,0,1-.7.28h0Z"
                                            transform="translate(-2720.88 -3821.84)"/>
                                    </svg>
                                  </span>
                                </div>
                            </nav>

                            <div className="ui-pages">
                                {
                                    UiPageList.map((List, index) => {
                                        return (
                                            <div className="ui-page" data-page={List.id} key={index}>
                                                <p className="count">{List.id + 1} / {UiPageList.length}</p>
                                                <span className="question">{List.text}</span>
                                            </div>
                                        )
                                    })
                                }
                            </div>
                        </div>
                    </div>
                )
            }
            {
                isResult && (
                    <div className={"result " + bg}>
                        <input type="radio" name="choice" id="result-nav-1" onClick={() => setBg('left')}/>
                        <input type="radio" name="choice" id="result-nav-2" onClick={() => setBg('center')} defaultChecked={true}/>
                        <input type="radio" name="choice" id="result-nav-3" onClick={() => setBg('right')}/>

                        <div id="result-app">
                            <nav className="ui-nav">
                                <div className="ui-bg">
                                    <div className="ui-cutout"/>
                                    <div className="ui-dot"/>
                                </div>
                                <label htmlFor="result-nav-1" className="ui-label">
                                    <span className="ui-icon">
                                        <img src={require("./img/heart.png")} alt="연애확률"/>
                                    </span>
                                </label>
                                <label htmlFor="result-nav-2" className="ui-label">
                                    <span className="ui-icon">
                                        <Icon2/>
                                    </span>
                                </label>
                                <label htmlFor="result-nav-3" className="ui-label">
                                    <span className="ui-icon">
                                        <Icon3/>
                                    </span>
                                </label>
                            </nav>

                            <div className="ui-pages">
                                <article className="ui-page" data-page="1">
                                    <div className="all-result">
                                        <div className="wrap">
                                            <img src={require("./img/flower.png")} alt="꽃" />

                                            <div className="text-box">
                                                <div className='title'>
                                                    <p>애인없는 것만 빼면</p>
                                                    <p>완벽한 당신!</p>
                                                </div>
                                                <div className="descript">
                                                    <div className="container">
                                                        <p>당신에게 포데이트가 드리고 싶은건 </p>
                                                        <p>단순히 남자친구,여자친구가 아니에요.</p>
                                                    </div>

                                                    <div className="container">
                                                        <p>당신이 <span className="bold">‘지금보다 더 행복해지는 것’</span>이에요.</p>
                                                    </div>

                                                    <div className="container">
                                                        <p>‘혼자인게 편해.혼자인게 좋아.’ 라고 말하는 당신도.</p>
                                                        <p>‘지금도 충분히 행복해.’ 라고 생각하는 당신도,</p>
                                                        <p>‘연애는 어려워’. 라며 맘을 닫는 당신도,</p>
                                                    </div>

                                                    <div className="container">
                                                        <p className="bold">지금보다 더 행복해질 수 있도록</p>
                                                        <p className="bold">당신에게 딱 맞는 ‘좋은연애’를 드릴게요.</p>
                                                    </div>
                                                </div>
                                            </div>

                                            <button type="button" className="goto" onClick={link}>
                                                <span>좋은 연애 하러가기</span>
                                            </button>
                                        </div>
                                    </div>
                                </article>

                                <article className="ui-page" data-page="2">
                                    <div className="redo">
                                        <div className="top">
                                            <Logo style={{width: "180px"}}/>

                                            <p className="title">당신이 3달안에 연애할 확률은?</p>

                                            <div className="circle_btn" onClick={redo}>
                                                <span className="result_rate">
                                                    {result}%
                                                </span>
                                            </div>

                                        </div>

                                        <div className="sub-result">
                                            <Face/>
                                            <Know/>
                                            <Attitude/>
                                        </div>

                                        <div className="main-result">
                                            <Result/>
                                        </div>

                                        <div className="bt_container">
                                            <button type="button" className="link-btn btn" onClick={link}>
                                                <span>
                                                    한달안에 연애하려면?
                                                </span>
                                            </button>

                                            <button type="button" className="redo-btn btn" onClick={redo}>
                                                <span>
                                                    검사 다시하기
                                                </span>
                                            </button>

                                            <button type="button" className="share-btn btn" data-clipboard-text={document.location.href.indexOf('clipboard_url') > -1 ? document.location.href.split('=')[1] : document.location.href} onClick={Modal}>
                                                <span>
                                                    테스트 공유하기
                                                </span>
                                            </button>
                                        </div>
                                    </div>
                                </article>

                                <article className="ui-page" data-page="3">
                                    <div className="link">
                                        <div className="wrap">
                                            <div className="container">
                                                <img src={require("./img/onedaydate.png")} alt="전체 백그라운드"/>
                                                <button type="button" className="link-btn" onClick={link}>
                                                    <span>
                                                        한달연애 알아보기
                                                    </span>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </article>
                            </div>
                        </div>
                    </div>
                )
            }
            {
                isLoading && <Loading/>
            }
        </>
    );
}

export default App;
